import { AuthService } from "src/app/core/endpoints/auth.service";
import { Utils } from "src/app/app.utils";
import { Component, ElementRef, OnInit, Renderer2, ViewChild } from "@angular/core";
import { AppConfig } from "src/app/api/appconfig";
import { ApiService } from "src/app/core/services/api.service";
import { NotificationService } from "src/app/service/notification.service";
import { environment } from "src/environments/environment";
import { ToastService } from "src/app/core/services/toast.service";
import { Investment, CURRENCY_SYMBOLS, InvestmentCurrency } from 'src/app/core/endpoints/models/investments';
import { Transaction } from "src/app/core/endpoints/models/transactions";
import { Chart, registerables, CategoryScale, LinearScale, BarController, BarElement } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(...registerables, CategoryScale, LinearScale, BarController, BarElement, ChartDataLabels);

@Component({
	templateUrl: "./graphics.component.html",
	styleUrls: ["./graphics.component.scss"],
})
export class GraphicsComponent implements OnInit {
	public loading = false;
	public chartOptions: any;
	public config: AppConfig;
	public location: any;
	public stringLocation: any;
	public locationGps: any;
	public data: any;
	versionApp:any = "";
	@ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  	investment: Investment;
	transactions: Transaction[] = [];
	transactionsGraphics:any;

    barChart: any;
    @ViewChild('barCanvas') barCanvas:any;

	constructor(
		public utils: Utils, 
    	private renderer: Renderer2,
		private apiService: ApiService,
		public notificationService: NotificationService,
		public toastService: ToastService
	) {
		
	}

	ngOnInit(): void {
		const wrapper = document.querySelector('.layout-wrapper');
		if (wrapper) {
		this.renderer.addClass(wrapper, 'layout-theme');
		}
		let uuid = localStorage.getItem('investment');
		if (uuid){
		this.loadInvestment(uuid);
		}
	}
	
	ngOnDestroy(): void {
		const wrapper = document.querySelector('.layout-wrapper');
		if (wrapper) {
		this.renderer.removeClass(wrapper, 'layout-theme');
		}
	}

	loadInvestment(uuid:any) {
		this.loading = true;
		this.apiService.getEntity('investments',uuid).subscribe({
		next: (result) => {
			this.investment = result.investments;
			this.loadTransactions();
			this.loadTransactionsGraphics();
		},
		error: (err) => {
			console.error(err);
			this.loading = false;
		},
		complete: () => {
			this.loading = false;
		}
		});
	}
	
	loadTransactions() {
		let uuid :any = localStorage.getItem('investments');
		this.apiService.getEntity('transactions/'+this.investment.id).subscribe({
		next: (result) => {
			this.transactions = result.transactions;
		},
		error: (err) => {
			console.error(err);
		}
		});
	}

	loadTransactionsGraphics() {
		let uuid :any = localStorage.getItem('investments');
		this.apiService.getEntity('transactionsGraphics/'+this.investment.id).subscribe({
		next: (data) => {
			this.transactionsGraphics = data;
              this.generateChart(data);
		},
		error: (err) => {
			console.error(err);
		}
		});
	}

	getUser() {
		return AuthService.getDataUser();
	}

	getAuthToken() {
		return AuthService.getAuthToken();
	}

	generateChart(data:any) {
		if (this.barChart){
		this.barChart.destroy();
		}
		const symbol = this.getCurrencySymbol(this.investment?.currency);
		Chart.defaults.font.family = "Montserrat";
		this.barChart = new Chart(this.barCanvas.nativeElement, {
		type: 'bar',
		data: {
			labels: data.month_names,
			datasets: [
			{
				label: 'Saldo mensual ' + symbol,
				data: data.dataMonths,
				backgroundColor: '#E69A51',
				borderWidth: 0,
			},
			],
		},
		options: {
			responsive: true,
			maintainAspectRatio: false,
			scales: {
			x: {
				ticks: {
				color: '#ffffff',
				},
				grid: {
				display: false,
				},
			},
			y: {
				ticks: {
				color: '#ffffff',
				callback: (value) => (value + symbol),
				},
				grid: {
				color: 'rgba(255, 255, 255, 0.2)',
				},
			},
			},
			plugins: {
			legend: {
				display: true,
				labels: {
				color: '#ffffff',
				font: {
					weight: 'bold',
				},
				},
			},
			datalabels: {
				anchor: 'end',
				align: 'bottom',
				color: '#ffffff',
				font:{
				size: 10,
				weight: 'bold'
				},
				formatter: (value:any) => (value + symbol),
			},
			},
		},
		});
	}
	
  truncateText(text: string, limit:number = 100): string {
    if (text){
      return text.length > limit ? text.slice(0, limit) + "..." : text;
    }
    return '';
  }
  
  formatNumber(num: number): string {
    const fixedNum = num.toFixed(2);
    const [integerPart, decimalPart] = fixedNum.split('.');
    const withThousands = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if(parseFloat(decimalPart) === 0){
      return withThousands;
    }
    return `${withThousands},${decimalPart}`;
  }

  getCurrencySymbol(currency?: InvestmentCurrency): string {
    return CURRENCY_SYMBOLS[currency] || CURRENCY_SYMBOLS['EUR'];
  }
  
}
